import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { Button, Form } from "reactstrap";

import Welcomegreet from "components/Welcomegreet";

//i18n
import { withTranslation } from "react-i18next";

import { Col, Container, Row, Spinner } from "reactstrap";

//Import Breadcrumb

import SearchInput from "components/Common/SearchInput";

import {
  getParkingOwnersRequest,
  removeParkingOwnerRequest,
} from "store/actions";
import UsersColumns from "./Columns";
import UsersConfirmModal from "./ConfirmModal";
import AddParkingOwner from "components/Modals/AddParkingOwner";

const ParkingOwners = (props) => {
  const {
    history,
    users,
    totalUsers,
    getParkingOwnersRequest,
    removeParkingOwnerRequest,
    loading,
  } = props;
  const [confirmModal, setConfirmModal] = useState({
    isOpen: false,
    userId: null,
  });
  const [showAddModal, setShowAddModal] = useState(false);

  const [filter, setFilter] = useState({
    orderBy: "createdAt",
    order: -1,
    page: 1,
    limit: 10,
  });
  const [searchText, setSearchText] = useState("");
  const [rowData, setRowData] = useState(null);
  const pageOptions = {
    sizePerPage: 10,
    totalSize: totalUsers,
    custom: true,
    onPageChange: (page) => setFilter((prevState) => ({ ...prevState, page })),
  };

  useEffect(() => {
    getParkingOwnersRequest({ ...filter });
  }, [JSON.stringify(filter)]);

  // eslint-disable-next-line no-unused-vars
  const handleTableChange = (type, { searchText, sortField, sortOrder }) => {
    if (type === "search") {
      setSearchText(searchText);
    }

    if (type === "sort") {
      if (sortField == "createdAt") {
        sortField = "date_created_utc";
      }

      if (sortOrder == "desc") {
        sortOrder = -1;
      } else if (sortOrder == "asc") {
        sortOrder = 1;
      }

      setFilter((prevState) => ({
        ...prevState,
        orderBy: sortField,
        order: sortOrder,
      }));
    }
  };

  const toggleConfirmModal = (userId) => {
    setConfirmModal((prevState) => ({ isOpen: !prevState.isOpen, userId }));
  };

  const removeConfirm = () => {
    const { userId, isOpen } = confirmModal;

    const onComplete = () => {
      getParkingOwnersRequest(filter);
    };

    setConfirmModal({ isOpen: !isOpen, userId: null });
    removeParkingOwnerRequest({ _id: userId }, onComplete);
  };

  const onSearch = (event) => {
    event.preventDefault();

    setFilter((prevState) => ({ ...prevState, search: searchText }));
  };

  const onEditHandler = (data) => {
    setRowData(data);
    setShowAddModal(true);
  };

  const onFinishAddEdit = () => {
    setRowData(null);
    getParkingOwnersRequest(filter);
  };
  

  // Function to convert data to CSV and trigger download
  const convertAndDownloadCSV = () => {
    // Convert the data to a CSV string
    const csv = convertDataToCSV(users);

    // Create a Blob object for the CSV data
    const blob = new Blob([csv], { type: 'text/csv' });

    // Create a URL for the Blob
    const url = window.URL.createObjectURL(blob);

    // Create a link element to trigger the download
    const a = document.createElement('a');
    a.href = url;
    a.download = `${new Date().getTime()}.csv`;

    // Trigger the download
    a.click();

    // Clean up resources
    window.URL.revokeObjectURL(url);
  };

  // Function to convert data to CSV format
  const convertDataToCSV = (data) => {
    // Implement the logic to convert your data into CSV format here
    // For a more complex data structure, you may want to use a library like 'json2csv'
    const header = Object.keys(data[0]).join(',') + '\n';
    const csvData = data.map((row) => Object.values(row).join(',')).join('\n');
    return header + csvData;
  };



  return (
    <React.Fragment>
      <UsersConfirmModal
        isOpen={confirmModal.isOpen}
        toggle={toggleConfirmModal}
        onConfirm={removeConfirm}
      />
      {showAddModal && (
        <AddParkingOwner
          data={rowData}
          show={showAddModal}
          onFinish={onFinishAddEdit}
          onhide={() => setShowAddModal(false)}
        />
      )}
      <div className="page-content">
        <Container fluid>
          <Welcomegreet />
          <div className="fillter_ssection mt-5">
            <Form>
              <div className="latest_cust_table mt-4">
                {/* <Newlist/> */}

                <Row>
                  <Col xs="12">
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="_id"
                          data={users}
                          columns={UsersColumns(
                            toggleConfirmModal,
                            onEditHandler,
                            props.t
                          )}
                          bootstrap4
                          search
                        >
                          {(toolkitProps) => (
                            <React.Fragment>
                              <Row>
                                <Col lg={6} md={12} sm={12}>
                                  <div className="custom-flex-sm d-flex align-items-center">
                                    <div className="search d-flex align-items-center">
                                      <div className="pl-3">
                                        <SearchInput
                                          {...toolkitProps.searchProps}
                                          triggerSearch={onSearch}
                                          placeholder={props.t("search")}
                                          searchText={searchText}
                                        />
                                      </div>
                                      <div className="pl-3">
                                        <span onClick={convertAndDownloadCSV} style={{ fontSize: '17px', cursor: "pointer" }}>
                                          <i className="fas fa-file-export"></i> Export Data
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </Col>
                                <Col className="mb-3" xs={12} md={6} lg={6}>
                                  <div className="text-sm-left text-md-right">
                                    <Button
                                      type="button"
                                      color="success"
                                      className="btn-rounded waves-effect waves-light mb-2 mr-2"
                                      onClick={() => setShowAddModal(true)}
                                    >
                                      <i className="mdi mdi-plus mr-1" />
                                      {props.t("add_parking_owner")}
                                    </Button>
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col xl="12">
                                  <div className="table-responsive spinner-content mt-3">
                                    <BootstrapTable
                                      responsive
                                      remote
                                      bordered={false}
                                      striped={false}
                                      classes={
                                        "table table-centered table-nowrap"
                                      }
                                      headerWrapperClasses={"thead-light"}
                                      {...toolkitProps.baseProps}
                                      onTableChange={handleTableChange}
                                      {...paginationTableProps}
                                      defaultSorted={[
                                        {
                                          dataField: "createdAt",
                                          order: "desc",
                                        },
                                      ]}
                                      sort={{
                                        sortCaret: (order) =>
                                          order === "asc" ? (
                                            <span className="caret">
                                              <i className="bx bx-caret-up" />
                                            </span>
                                          ) : order === "desc" ? (
                                            <span className="caret">
                                              <i className="bx bx-caret-down" />
                                            </span>
                                          ) : null,
                                      }}
                                    />

                                    {loading && (
                                      <div className="spinner">
                                        <Spinner color="primary" />
                                      </div>
                                    )}
                                  </div>
                                </Col>
                              </Row>
                              <Row className="align-items-md-center mt-30">
                                <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </Col>
                </Row>
              </div>
            </Form>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = ({ customers }) => ({
  loading: customers.loading,
  users: customers.parkingOwners,
  totalUsers: customers.totalParkingOwners,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getParkingOwnersRequest: (data) => {
      dispatch(getParkingOwnersRequest(data));
    },
    removeParkingOwnerRequest: (data, callback) => {
      dispatch(removeParkingOwnerRequest(data, callback));
    },
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ParkingOwners))
);
